export default {
      id: "oc-cnware-usage",
      viewBox: "0 0 1123 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-cnware",
      toString: function () {
        return this.url;
      }
    }